'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _MessageWarning = require('./MessageWarning');

var _MessageWarning2 = _interopRequireDefault(_MessageWarning);

var _linksoftAlbatros = require('linksoft-albatros');

var _localize = require('linksoft/core/localize');

var _localize2 = _interopRequireDefault(_localize);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Resx = (0, _localize2.default)('Messages', 'App');

function mapStateToProps(state) {
    var upcomingDate = null;

    if (state.cart && state.cart.items) {
        var dateFilter = function dateFilter(date) {
            return date && (date instanceof Date || typeof date === 'string');
        };
        var now = new Date();
        var upcomingDates = state.cart.items.filter(function (f) {
            return ((f.amountAvailable || f.amountCentralAvailable) === 0 || new Date(f.dispatchDate) > now) && (dateFilter(f.dispatchDate) || dateFilter(f.upcomingDate));
        }).map(function (x) {
            return new Date(x.upcomingDate || x.dispatchDate);
        }).sort(function (a, b) {
            var diff = b - a;
            if (diff > 0) return 1;else if (diff < 0) return -1;else return 0;
        });
        if (upcomingDates.length > 0) upcomingDate = upcomingDates[0];
    }
    return {
        isAnyProductOutOfStock: state.cart.isAnyProductOutOfStock,
        upcomingDate: upcomingDate
    };
}

var DispatchWarning = (_dec = (0, _reactRedux.connect)(mapStateToProps), _dec(_class = (_temp = _class2 = function (_React$PureComponent) {
    (0, _inherits3.default)(DispatchWarning, _React$PureComponent);

    function DispatchWarning() {
        (0, _classCallCheck3.default)(this, DispatchWarning);
        return (0, _possibleConstructorReturn3.default)(this, (DispatchWarning.__proto__ || (0, _getPrototypeOf2.default)(DispatchWarning)).apply(this, arguments));
    }

    (0, _createClass3.default)(DispatchWarning, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                isAnyProductOutOfStock = _props.isAnyProductOutOfStock,
                upcomingDate = _props.upcomingDate;

            if (isAnyProductOutOfStock === true && upcomingDate) {
                return _react2.default.createElement(_MessageWarning2.default, {
                    icon: 'icon--hint',
                    text: (0, _linksoftAlbatros.stringFormat)(Resx.Messages.SomeProductIsOutOfStockMessage, (0, _linksoftAlbatros.format)(upcomingDate, 'd')) });
            }
            return null;
        }
    }]);
    return DispatchWarning;
}(_react2.default.PureComponent), _class2.propTypes = {
    isAnyProductOutOfStock: _propTypes2.default.bool,
    upcomingDate: _propTypes2.default.instanceOf(Date)
}, _temp)) || _class);
exports.default = DispatchWarning;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/cart/components/cartDetail/DispatchWarning.js
// module id = 566
// module chunks = 0